module.exports = "<div class=\"background\" [ngStyle]=\"{ 'background-image': 'url(' + imageUrl + ')'}\"></div>\n\n<div appBgOpacityScroll>\n  <app-main-navbar></app-main-navbar>\n  <div class=\"container-fluid\">\n    <router-outlet></router-outlet>\n  </div>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/general-view/general-view.component.html
// module id = ./src/app/views/general-view/general-view.component.html
// module chunks = main